import { Paper, styled } from "@mui/material";
import { blue } from "@mui/material/colors";

import { withDefaultProps } from "fond/utils/withDefaultProps";

export const ReportConfigurationSection = styled("fieldset")`
  border: none;
  padding: 0;
  margin: 0;

  &:not(.is-editing) {
    input,
    button,
    .Mui-disabled {
      cursor: not-allowed;
    }
  }
`;

const Paper0 = withDefaultProps(Paper, { elevation: 0 });
export const Disclaimer = styled(Paper0)`
  background-color: ${blue[50]};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => theme.spacing(4)};
`;
